import { cx } from "@light-technology/components";
import { type ReactNode, useState } from "react";

type HoverCardProps = {
  children: ReactNode;
  className?: string;
  /** Styles the outer wrapper, which the hover offset is measured against. */
  wrapperClassName?: string;
};

export const HoverCard = ({
  children,
  className = "",
  wrapperClassName = "",
}: HoverCardProps) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={cx("group p-[4px_0_0_4px]", wrapperClassName)}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <div
        className={cx(
          "flex cursor-pointer rounded-xl border border-secondary bg-primary p-6 transition-all duration-200 ease-in-out group-hover:border-primary",
          className,
        )}
        style={{
          boxShadow: hovered
            ? "-4px 4px 0px 0px rgba(0,0,0,1), -3px 3px 0px 0px rgba(0,0,0,1), -2px 2px 0px 0px rgba(0,0,0,1), -1px 1px 0px 0px rgba(0,0,0,1)"
            : "none",
          transform: hovered ? "translate(0, 0)" : "translate(-4px, 4px)",
        }}
      >
        {children}
      </div>
    </div>
  );
};
